import useAuth from 'features/auth/hooks/use-auth';
import LogOutButton from 'shared/components/buttons/logout';
import * as React from 'react';
import LogInButton from 'shared/components/buttons/login';

const DefaultHeaderControlsMenu = () => {
  const { state } = useAuth();

  if (state.isAuth) {
    return <LogOutButton />;
  }
  return <LogInButton />;
};

export default DefaultHeaderControlsMenu;
